"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Checkbox = _interopRequireDefault(require("../Input/CheckBox/Checkbox"));

var _ButtonIcon = _interopRequireDefault(require("../ButtonIcon/ButtonIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./SelectListItem.scss");

require("./SelectListItemDark.scss");

var _reactstrap = require("reactstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SelectListItem = function SelectListItem(_ref) {
  var idCheck = _ref.idCheck,
      label = _ref.label,
      checked = _ref.checked,
      disabledCheck = _ref.disabledCheck,
      selected = _ref.selected,
      onCheckChange = _ref.onCheckChange,
      onEdit = _ref.onEdit,
      onDelete = _ref.onDelete,
      onSelected = _ref.onSelected,
      disabledDelete = _ref.disabledDelete,
      disabledEdit = _ref.disabledEdit,
      tooltips = _ref.tooltips;

  var _useState = (0, _react.useState)(selected),
      _useState2 = _slicedToArray(_useState, 2),
      _selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(checked),
      _useState4 = _slicedToArray(_useState3, 2),
      _checked = _useState4[0],
      setChecked = _useState4[1];

  (0, _react.useEffect)(function () {
    _selected !== selected && setSelected(selected);
  }, [selected]);
  (0, _react.useEffect)(function () {
    _checked !== checked && setChecked(_checked);
  }, [checked]);

  var selectedChange = function selectedChange() {
    if (!_selected) {
      setSelected(true);
      onSelected(idCheck);
    }
  };

  var onChecked = function onChecked(flag) {
    onCheckChange({
      id: idCheck,
      value: flag
    });
    setChecked(flag);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-selectList-item ".concat(_selected ? 'selected' : '', " ").concat(_checked ? 'checked' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-selectList-item-title'
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    id: idCheck,
    checked: checked,
    disabled: disabledCheck,
    onChange: onChecked
  }), /*#__PURE__*/_react["default"].createElement("span", {
    id: 'gcl-selectList-item-label-' + idCheck
  }, label), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: 'gcl-selectList-item-label-' + idCheck
  }, label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-selectList-item-btns ".concat(_selected && 'selected', " ")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-selectList-container'
  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
    id: "trash-".concat(idCheck),
    icon: "trash",
    onClick: function onClick() {
      return onDelete(idCheck);
    },
    disabled: disabledDelete
  })), /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
    icon: "chevron-right",
    shape: "circle",
    onClick: selectedChange
  })), tooltips && tooltips["delete"] && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: "trash-".concat(idCheck)
  }, tooltips["delete"]));
};

SelectListItem.propTypes = {
  idCheck: _propTypes["default"].isRequired,
  label: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  disabledCheck: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  disabledEdit: _propTypes["default"].bool,
  disabledDelete: _propTypes["default"].bool,
  onCheckChange: _propTypes["default"].func,
  onEdit: _propTypes["default"].func,
  onDelete: _propTypes["default"].func,
  onSelected: _propTypes["default"].func,
  tooltips: _propTypes["default"].shape({
    "delete": _propTypes["default"].string,
    select: _propTypes["default"].string
  })
};
SelectListItem.defaultProps = {
  checked: false,
  disabledCheck: false,
  selected: false,
  disabledEdit: false,
  disabledDelete: false,
  onCheckChange: function onCheckChange() {},
  onEdit: function onEdit() {},
  onDelete: function onDelete() {},
  onSelected: function onSelected() {}
};
var _default = SelectListItem;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/SelectListItem/SelectListItem.js
// module id = 1914
// module chunks = 0